<vt-styled-authorization-page [content]="information"></vt-styled-authorization-page>

<ng-template #information>
    <vt-information></vt-information>
</ng-template>